import styles from './style.module.css';
import logo from './logo_offwhite.png'
export default function TopNav(props) {
    return <div className={styles.topNav}>
        <img src={logo} alt="logo"/>
        {props.children}
    </div>
}